import React from 'react';
import './under-construction.css';

const UnderConstruction = () => {
    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="app-container">
                    <div className="overlay d-flex justify-content-center align-items-center">
                        <div className="construction-container text-center p-5">
                            <h1 className="display-4 text-warning">🚧 Under Construction 🚧</h1>
                            <p className="lead text-light mb-4">We're working hard to get things ready! Please check back soon.</p>
                            <div className="construction-icon fs-1 mb-3">⚒️</div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UnderConstruction;
